module.exports = __webpack_public_path__ + "frontend/images/white/carousel/europe@2.png?3fc58b1c858dc4caea0d126ee7dc9511";